import { shape, number } from 'prop-types';

export default shape({
    id: number.isRequired,
});
